/**
 * Lê o valor gravado de um campo `multi_select` como lista de opções.
 *
 * O formato canônico é array de strings, mas a base tem outros: até a correção de
 * 2026-10-19 a edição inline tratava o campo como seleção simples e gravava UMA
 * string; e o webhook de entrada gravava tudo com `String()`, então `["A","B"]`
 * virava `"A,B"`. Ler só `Array.isArray` faria esses registros parecerem vazios —
 * e o próximo salvamento apagaria o dado.
 *
 * String que é exatamente uma opção fica inteira (opção pode ter vírgula); senão é
 * quebrada em `,`/`;`.
 */
export function lerMultiSelecao(value: unknown, opcoes: readonly string[] = []): string[] {
  if (value === null || value === undefined) return [];

  const itens = Array.isArray(value)
    ? value.map((v) => String(v ?? ""))
    : typeof value === "string"
      ? opcoes.includes(value.trim())
        ? [value]
        : value.split(/[;,]/)
      : [String(value)];

  const out: string[] = [];
  for (const item of itens) {
    const t = item.trim();
    if (t && !out.includes(t)) out.push(t);
  }
  return out;
}
